import { PresetColors } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab";

// What fills the canvas around the framed picture on fcb_matchday_slider_2.
//
// This template's picture is a box in the middle of the page rather than a
// full-bleed background, so the canvas behind it is on show and has to carry
// the artwork instead. Which artwork depends on the kit the overlay is drawn
// in and on the competition, and BOTH the editor canvas and the template have
// to answer that question the same way -- the editor previews it and the
// template exports it -- so the answer lives here and they each call it.
//
// The artwork is this template's own set, in ./images -- one file per state.

import whiteBg from "./images/background_white.webp";
import redBg from "./images/background_red.webp";
import blackBg from "./images/background_black.webp";
import uclBg from "./images/background_UCL.webp";
import dfbBg from "./images/background_DFB.webp";

// The edge drawn around the framed picture (frame.js draws the shape; this is
// its colour).
//
// Only one case is not white: the white kit, whose canvas is near-white and
// would swallow a white edge, so it flips to the same #de0034 the overlay
// paints its type in there. That reasoning is about the CANVAS, not the kit,
// so the competition toggles have to be read too -- a white-kit cup or
// European tie puts dark artwork on the canvas, where white is right again.
export const getSlider2EdgeColor = ({ jersey, hasCLStars, isDfbPokal } = {}) => {
  if (isDfbPokal || hasCLStars) return "#ffffff";
  return jersey === PresetColors.white || jersey === undefined
    ? "#de0034"
    : "#ffffff";
};

// One artwork per state. All five are cut at 1200x1500 only, so `cover` below
// is what fits them to the other two formats -- see the note on the resolver.
const ARTWORK = {
  white: whiteBg,
  red: redBg,
  black: blackBg,
  ucl: uclBg,
  pokal: dfbBg,
};

const paint = (url) => `url(${url}) center / cover no-repeat`;

// Resolves the canvas background from the current editor state.
//
// The order is a precedence chain, not a set of independent switches: the cup
// and European artwork REPLACE the club background rather than decorating it,
// so whichever is on wins over the kit colour. Pokal is checked first because
// a cup tie is a cup tie whatever else is toggled.
//
// There is no format argument: the artwork is supplied at 1200x1500 only, and
// `cover` in paint() fits it to the canvas. On 1080x1920 and 1920x1080 that
// means a real crop off the sides or the top and bottom, since neither is
// anywhere near 4:5. Add per-format cuts here if those two need to be exact.
export const getSlider2Background = ({ jersey, hasCLStars, isDfbPokal } = {}) => {
  if (isDfbPokal) return paint(ARTWORK.pokal);
  if (hasCLStars) return paint(ARTWORK.ucl);
  if (jersey === PresetColors.red) return paint(ARTWORK.red);
  if (jersey === PresetColors.black) return paint(ARTWORK.black);

  return paint(ARTWORK.white);
};
